import { useState } from "react";
import { Tooltip, Button } from "@mui/material";

const API = process.env.REACT_APP_API_URL;

export default function AttachmentPreview({ file }) {
  const [preview, setPreview] = useState(null);

  const authHeaders = () => {
    const token = localStorage.getItem("token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const loadPreview = async () => {
    if (preview) return; // ya cargada

    const res = await fetch(`${API}/emails/attachment/${file.id}/preview`, {
      headers: authHeaders(),
    });
    if (!res.ok) return;
    const blob = await res.blob();
    setPreview(URL.createObjectURL(blob));
  };

  const handleDownload = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const res = await fetch(`${API}/emails/attachment/${file.id}/download`, {
      headers: authHeaders(),
    });
    if (!res.ok) {
      alert("No se pudo descargar el adjunto.");
      return;
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = file.filename || "adjunto";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <Tooltip
      title={
        preview ? (
          file.filename.toLowerCase().endsWith(".pdf") ? (
            <embed
              src={preview}
              type="application/pdf"
              width="340"
              height="400"
              style={{ borderRadius: 6 }}
            />
          ) : (
            <img
              src={preview}
              width="340"
              alt="preview"
              style={{ borderRadius: 6 }}
            />
          )
        ) : (
          "Cargando..."
        )
      }
      onOpen={loadPreview} // carga cuando hace hover
      arrow
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "white",
            color: "black",
            boxShadow: "0px 3px 12px rgba(0,0,0,0.25)",
            borderRadius: "8px",
            p: 1,
          },
        },
      }}
    >
      <Button
        variant="outlined"
        size="small"
        onClick={handleDownload}
      >
        📎 {file.filename}
      </Button>
    </Tooltip>
  );
}
